import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit } = measures

export const fileContainer = (isDisable) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 41px;
  background: ${isDisable ? colors.black10 : colors.blues.blue1};
  font-weight: bold;
`

export const fileInput = css`
  opacity: 0;
  position: absolute;
`

export const label = (isPlaceholder) => css`
  overflow: hidden;
  margin-right: ${unit}px;
  color: ${isPlaceholder ? colors.greens.green6 : colors.white40};
  display: flex;
  align-items: center;
  font-family: Montserrat, Arial, Helvetica, sans-serif;
`

export const icon = css`
  cursor: pointer;
`
